import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA } from 'src/app/constantes/permissao.constants';
import { Arquivo, LabelTipoConteudo, TipoConteudo as TipoConteudo } from 'src/app/model/arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { EmpresasBloqueadas, consultaCNPJExemplo } from 'src/app/model/empresas-bloqueadas.model';
import { timeHours } from 'd3';
import { EmpresasBloqueadasService } from './empresas-bloqueadas.service';


@Component({
    selector: 'app-empresas-bloqueadas-lote',
    templateUrl: './empresas-bloqueadas-lote.component.html',
    styleUrls: ['./empresas-bloqueadas-lote.component.scss'],
    standalone: false
})
export class EmpresasBloqueadasLoteComponent implements OnInit {

  @ViewChild(BnConfirmDirective, {static: false}) bnConfirm: BnConfirmDirective;

  loteCnpjForm: UntypedFormGroup;

  arquivo: Arquivo;
  labelTipoConteudo: string;
  filecontentTemplate = '';

  private modalidadeGarantia: string;
  termoModalidade: string;

  private enviado: boolean = false;

  private ocorrencias: OcorrenciaValidacaoVO[] = [];

  private cnpjUsuario: string;

  private isAgente: boolean;

  private arquivoEmpresa: EmpresasBloqueadas;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: EmpresasBloqueadasService,
    private router: Router,
    private bnAlertsService: BnAlertsService,
    private fileUtils: FileUtilsService,
    private messageService: MessageChannelService,
    private bnUsuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private removerAlertasService: RemoverAlertasService,
    private loadingService: BnLoadingService,
    private modalidadeService: ModalidadeService) {
  }

  ngOnInit() {
    this.createReactiveForm();

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario.cnpj;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.isAgente = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.modalidadeService.modalidade$.subscribe((mod) =>{
      this.modalidadeGarantia = mod;
      for (let modalidade of this.modalidadeService.getModalidades()) {
        if (modalidade.sigla == mod) {
          this.termoModalidade = modalidade.textoTermoEmpresasBloqueadas;
        }
      }
  })

  }

   createReactiveForm() {
    this.loteCnpjForm = this.formBuilder.group({
      arquivo: ['', Validators.required],
      checkCiencia: ['', [Validators.required, Validators.pattern('true')]]
    });
  }

  baixarExemploConsultaCNPJ() {
    let conteudoArquivoExemplo!: string;

    conteudoArquivoExemplo = consultaCNPJExemplo;

    this.fileUtils.exportarArquivo('exemplo-consulta-cnpj.json', conteudoArquivoExemplo, FileUtilsService.APPLICATION_JSON);
  }

  onFileChange(event) {
    let marcador = new MarcadorTempo("onFileChange");
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    this.loteCnpjForm.markAsDirty();
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      if (!this.suportaTamArquivo(file.size)) {
        console.log(`Arquivo muito grande ${file.size} bytes`);
        setTimeout(() => {
          this.limpar();
          this.bnAlertsService.alertaErro('Erro', `O arquivo ${file.name} é muito grande.`);
        }, 0);
        return;
      }
      marcador.marcaTempo("inicio");

      reader.readAsText(file, "UTF-8");
      reader.onload = () => {
        marcador.marcaTempo("readAsText");

        let conteudoArquivo: string = '';
        if (typeof reader.result === 'string') {
          conteudoArquivo = reader.result;
        } else {
          conteudoArquivo = this.fileUtils.lerConteudo(reader);
        }
        marcador.marcaTempo("lerConteudo");

        // evitar erros com estas aspas estranhas
        conteudoArquivo = conteudoArquivo.replace('“', '"').replace('”', '"');
        marcador.marcaTempo("replace");
        
        const lote = this.validarArquivo(file.name, file.type, conteudoArquivo);
        marcador.marcaTempo("validarArquivo");
        if (!lote) {
                    return;
        }

        this.arquivo = new Arquivo();
        this.arquivo.filename = file.name;
        this.arquivo.filetype = file.type;
        this.arquivo.value = conteudoArquivo;
        this.labelTipoConteudo = LabelTipoConteudo.get(this.arquivo.tipoConteudo);

        this.loteCnpjForm.updateValueAndValidity();
        marcador.marcaTempo("updateValueAndValidity");
      };
    }
  }

  onSubmit() {

    if (!this.arquivo.value) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não possui conteúdo.');
      return;
    }

    this.loteCnpjForm.disable();
    this.enviado = true;
    this.enviar();
  }

  enviar() {
    this.loadingService.bloqueiaTela();

    this.ocorrencias = [];

    let marcador = new MarcadorTempo("enviar");

    const msgService = this.messageService;
    const lote = JSON.parse(this.arquivo.value);
    marcador.marcaTempo("parse");

    const exibirMensagemSucesso = (res) => {
      this.loadingService.liberaTela();
      msgService.addMessage(this.gerarMensagemSucesso("cnpjs"));
      this.limpar();
      this.irParaTelaPesquisa();
    };

    const exibirMensagemErro = (err) => {
            this.loadingService.liberaTela();
      this.ocorrencias = this.service.ocorrencias;
      this.limpar();
      this.irParaTelaPesquisa();
    };

    this.service.consultarCnpjLote(lote).subscribe(exibirMensagemSucesso, exibirMensagemErro);
  }

  private gerarMensagemSucesso(cnpjs: string) {

    let msgSucesso: string;


    msgSucesso = `Todos os ${cnpjs} foram enviados com sucesso.`;

    return {
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: msgSucesso
    };
  }

  private validarArquivo(nomeArquivo, tipoArquivo, conteudoArquivo): Cnpj {
    if (tipoArquivo !== 'application/json') {
      this.bnAlertsService.alertaErro('Erro', `O sistema suporta apenas arquivos JSON - '${nomeArquivo}' --> '${tipoArquivo}'.`);
      this.limpar();
      return null;
    }

    if (conteudoArquivo === null || conteudoArquivo === '') {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo está vazio.');
      this.limpar();
      return null;
    }

    if (!Utils.isValidJson(conteudoArquivo)) {
      this.bnAlertsService.alertaErro('Erro', 'Não foi possível validar o arquivo JSON. ' +
        'Verifique se há erros de sintaxe no arquivo, como vírgulas mal colocadas ou chaves não fechadas. ' +
        'Uma sugestão é utilizar um dos vários sites de validação JSON disponíveis na web.');
      this.limpar();
      return null;
    }

    const conteudo = JSON.parse(conteudoArquivo);
    const lote = FabricaCnpj.criar(conteudo);

    if (lote === null) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não contém CNPJ.');
      this.limpar();
      return null;
    }


    const erro = lote.validar();
    if (erro !== null) {
        this.bnAlertsService.alertaErro('Erro', erro);
        this.limpar();
        return null;
    }

    this.arquivoEmpresa = conteudo;
    
    this.validaCnpjsDoLote();

    return lote;
  }

  validaCnpjsDoLote() {
    if (this.arquivoEmpresa.listaCnpj === null || this.arquivoEmpresa.listaCnpj === undefined) {
      this.bnAlertsService.alertaErro('Erro', 'O arquivo não contém CNPJ.');
      this.limpar();
      return null;
    }
  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.enviado || this.loteCnpjForm.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  verificaSePodeSair(): Observable<string> {
    this.bnConfirm.abrirModal();
    return this.bnConfirm.resultadoConfirm.asObservable();
  }

  baixarTabelaDeErros() {
    const ocorrenciasJson = JSON.stringify(this.ocorrencias);
    this.fileUtils.exportarArquivo('erros.json', ocorrenciasJson, FileUtilsService.APPLICATION_JSON);
  }

  ajustaDatas(): (key: any, obj: any) => any {
    let dateTimeFields:any = {};
    dateTimeFields.dataEnvio = "DateTime";
    dateTimeFields.dataReferenciaProtocolo = "Date";
    dateTimeFields.dataContratacao = "Date";
    dateTimeFields.dataReferenciaReceitaBruta = "Date";
    dateTimeFields.dataPrimeiraLiberacao = "Date";
    dateTimeFields.data = "Date";

    return ((key, obj) => {
      if (!dateTimeFields[key]) {
        return obj;
      }

      if (dateTimeFields[key] === "Date") {
        return moment(obj).format("YYYY-MM-DD");
      }

      if (dateTimeFields[key] === "DateTime") {
        return moment(obj).format("YYYY-MM-DDTHH:mm:ss.SSS");
      }

      // Não deve ter sobrado nada para cá
      return obj;
    })
  }

  tiposConteudo() {
    return TipoConteudo;
  }

  limpar() {
    this.arquivo = null;

    this.loteCnpjForm.reset();
    this.loteCnpjForm.markAsPristine();
    this.loteCnpjForm.enable();
    this.loteCnpjForm.updateValueAndValidity();

    this.enviado = false;
  }

  voltar() {
    this.router.navigate(["/empresas-bloqueadas"]);
  }

  private suportaTamArquivo(fileSizeBytes: number): boolean {
    // tenta descobrir o quanto temos de memória
    let memSizeBytes = undefined;
    let perf: any = window.performance;
    if (perf.memory) {
      memSizeBytes = perf.memory.jsHeapSizeLimit;
    }

    if (memSizeBytes) {
      const limiteBytes = Math.round(memSizeBytes / 30); // Número mágico, apurado com algumas medições
      console.log(`limiteArquivo - estimado pela memória livre. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    } else {
      const limiteBytes = 64 * 1024 * 1024; // 64 MB deve caber em uma máquina com 8GB
      console.log(`limiteArquivo - valor fixo. fileSizeBytes: ${fileSizeBytes} limiteBytes: ${limiteBytes}`);
      return fileSizeBytes < limiteBytes;
    }
  }

  irParaTelaPesquisa() {
    this.router.navigate(["/empresas-bloqueadas"]);
  }
}

class MarcadorTempo {
  private timestamp = Date.now();

  constructor(private nome:string) {}

  public inicia(): void {
    this.timestamp = Date.now();
  }

  public marcaTempo(msg: string): void {
    console.log(`[${this.nome}] ${msg} -`, (Date.now() - this.timestamp));
    this.inicia();
  }
}

abstract class Cnpj {
  conteudo: any;

  constructor(conteudo: any) {
    this.conteudo = conteudo;
  };

  abstract validar();
}

class ValidaCnpj extends Cnpj {

  private arquivoEmpresa: EmpresasBloqueadas;

  constructor(conteudo: any) {
    super(conteudo);
  };

  validar() {
    this.arquivoEmpresa = this.conteudo;
    let cnpjs: string[] = this.conteudo.listaCnpj;

    const qtdItens = Object.keys(cnpjs).length;
    if (qtdItens == null || qtdItens === undefined || qtdItens <= 0 || qtdItens > 10 || this.arquivoEmpresa == null || this.arquivoEmpresa === undefined) {
      return 'Arquivo JSON incorreto. Favor corrigir e enviar novamente.';
    }

    if(!this.validarCampos()) {
      return 'Favor adicionar CNPJ válido para consulta.'
    }

    return null;
  }

  validarCampos() {
    if(!(/^$/.test(this.arquivoEmpresa.listaCnpj.cnpj1))
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj2)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj3)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj4)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj5)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj6)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj7)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj8)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj9)
        || !this.campoValido(this.arquivoEmpresa.listaCnpj.cnpj10)
      ) {
      return false;
    }

    return true;
  }

  campoValido(campo: string) {
    if(campo != null || campo != undefined) {
      return (/^$/.test(campo));
    }
    return true;
  }

}

class FabricaCnpj {
  static criar(conteudo: any): Cnpj {
    if(conteudo.listaCnpj) {
      return new ValidaCnpj(conteudo);
    } else {
      return null;
    }
  }
}
